import { useState } from 'react';

import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import {
  ACCOUNT_USER_DETAIL_CART_LOG_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_CART_LOG_LIST_SORT_OPTION_MODEL,
} from './models';
import { ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE } from '../../../../../constants/service/app/accountUserConstants';
import { useAccountUserCartDetailQuery, useAccountUserDetailCartLogModalQuery } from './query';

export const useAccountUserCartDetail = ({ userId, isActive }) => {
  const { data } = useAccountUserCartDetailQuery({
    userId,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_CART_DETAIL_REQUEST_SUCCESS),
      onError: (error) => toastMsg.error(error.message),
      select: (result) => ({
        cartSummaryData: result.data.cartSummaryData,
        cartHistoryList: result.data.cartHistoryList.list,
      }),
    },
  });

  return data;
};

export const useAccountUserDetailCartLogModal = ({ userId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_CART_LOG_LIST_FILTER_OPTION_MODEL);
  const [sortOption, setSortOption] = useState(ACCOUNT_USER_DETAIL_CART_LOG_LIST_SORT_OPTION_MODEL);

  const { data } = useAccountUserDetailCartLogModalQuery({
    userId,
    filterOption,
    sortOption,
    options: {
      enabled: !!userId && isModalOpen,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_CART_LOG_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => result.data.userCartLogList,
    },
  });

  const openAddCartLogModal = () => {
    setFilterOption({ ...filterOption, actionLogType: ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.ADD });
    setIsModalOpen(true);
  };

  const openRemoveCartLogModal = () => {
    setFilterOption({ ...filterOption, actionLogType: ACCOUNT_USER_DETAIL_CART_LOG_LIST_ACTION_LOG_TYPE.REMOVE });
    setIsModalOpen(true);
  };

  const resetFilterOption = () => setFilterOption(ACCOUNT_USER_DETAIL_CART_LOG_LIST_FILTER_OPTION_MODEL);
  const resetSortOption = () => setSortOption(ACCOUNT_USER_DETAIL_CART_LOG_LIST_SORT_OPTION_MODEL);

  const closeModal = () => {
    resetFilterOption();
    resetSortOption();
    setIsModalOpen(false);
  };

  const getList = ({ filterOption, sortOption }) => {
    filterOption && setFilterOption(filterOption);
    sortOption && setSortOption(sortOption);
  };

  return {
    isModalOpen,
    userCartLogList: data || [],
    openAddCartLogModal,
    openRemoveCartLogModal,
    closeModal,
    filterOption,
    sortOption,
    getList,
  };
};
